// extracted by mini-css-extract-plugin
export default {"desktopWrapper":"_1Wfzn","priceButton":"_nJ2h","modalFieldValue":"_25VuF","tabsView":"HezC6"};